import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { useAuth } from '@/lib/auth';
import { getUnreadNotificationsCount, subscribeToNotifications } from '@/lib/notifications';
import { NotificationsPopup } from './NotificationsPopup';
import { cn } from '@/lib/utils';

export function NotificationBell() {
  const { user } = useAuth();
  const [unreadCount, setUnreadCount] = useState(0);
  const [showNotifications, setShowNotifications] = useState(false);

  useEffect(() => {
    if (user) {
      loadUnreadCount();
      
      // Subscribe to new notifications
      const subscription = subscribeToNotifications((notification) => {
        if (notification.user_id === user.id) {
          // Only increment count if notification is for current user
          setUnreadCount(prev => prev + 1);
        }
      });

      // Refresh count periodically to ensure accuracy
      const interval = setInterval(loadUnreadCount, 60000);

      return () => {
        subscription.unsubscribe();
        clearInterval(interval);
      };
    } else {
      // Reset count when user logs out
      setUnreadCount(0);
    }
  }, [user]);

  const loadUnreadCount = async () => {
    if (!user) return;
    const count = await getUnreadNotificationsCount();
    setUnreadCount(count);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setShowNotifications(!showNotifications)}
        className="relative p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
      >
        <Bell className="w-5 h-5 text-gray-600 dark:text-gray-300" />
        {unreadCount > 0 && (
          <span className={cn(
            "absolute top-0 right-0 w-5 h-5 bg-royal-purple text-white text-xs",
            "font-medium rounded-full flex items-center justify-center transform",
            "translate-x-1 -translate-y-1 animate-bounce"
          )}>
            {unreadCount}
          </span>
        )}
      </button>

      {showNotifications && (
        <NotificationsPopup
          onClose={() => setShowNotifications(false)}
          onNotificationsRead={loadUnreadCount}
        />
      )}
    </div>
  );
}